import { boot, isChapterName } from '@dazn/bootstrap-lib';
/**
 * This function normalizes all variations into a single output and is idempotent.
 *
 * There are multiple types and formats to represent a chapter, some are legac
 * As an Object
 * ```js
 * {
 * // chapter name
 *   chapterName: 'name',
 *   name: 'name',
 *   value: 'name',
 *
 * // additional data
 *   chapterData: { foo: 'bar' },
 *
 * // navigation path
 *   chapterPath: '/foo/bar',
 *   pathname: '/foo/bar',
 *   path: '/foo/bar',
 * }
 * ```
 *
 * As a stirng: 'catalog'
 */
const normalizeChapter = (
    chapter: boot.config.ChapterNameLike,
    currentChapterPath: string,
): boot.config.NormalChapterConfig | null => {
    const [chapterName, chapterData, chapterPath] =
        typeof chapter === 'string'
            ? [chapter, null, currentChapterPath]
            : [
                  chapter.chapterName || chapter.name || chapter.value,
                  chapter.chapterData ||
                      chapter.data ||
                      // FIXME: (Maxim) this is weird.
                      // We should deprecate this pattern
                      (chapter as unknown as boot.config.ChapterData) ||
                      null,
                  chapter.chapterPath ||
                      chapter.pathname ||
                      chapter.path ||
                      currentChapterPath,
              ];

    if (!isChapterName(chapterName)) {
        return null;
    }
    return {
        chapterName,
        chapterData,
        chapterPath,
    };
};

export { normalizeChapter };
